import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { useSite, telLink, waLink } from "@/context/SiteContext";

export default function CtaBand({ title = "Ready to Book Your Taxi?", subtitle = "Comfortable cars, professional drivers and honest fares across Rajasthan. Reserve your ride in minutes." }) {
  const s = useSite();
  return (
    <section className="section-pad" data-testid="cta-band">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-3xl bg-navy px-6 py-14 sm:px-12 sm:py-16 text-center">
          <div className="absolute -top-16 -right-16 w-64 h-64 bg-brand/20 rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -left-10 w-64 h-64 bg-brand-sky/10 rounded-full blur-3xl" />
          <div className="relative">
            <h2 className="text-2xl sm:text-4xl font-heading font-bold text-white max-w-2xl mx-auto">{title}</h2>
            <p className="mt-4 text-slate-300 max-w-xl mx-auto">{subtitle}</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/book-taxi" className="inline-flex items-center gap-2 bg-brand hover:bg-royal text-white font-semibold px-7 py-3.5 rounded-full transition-all active:scale-95 shadow-lg shadow-brand/30">Book a Taxi <ArrowRight className="w-4 h-4" /></Link>
              <a href={telLink(s)} className="inline-flex items-center gap-2 bg-white text-navy font-semibold px-7 py-3.5 rounded-full hover:bg-brand-light transition-colors"><Phone className="w-4 h-4" /> Call Now</a>
              <a href={waLink(s)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-whatsapp text-white font-semibold px-7 py-3.5 rounded-full hover:brightness-95 transition-all"><WhatsAppIcon className="w-5 h-5" /> WhatsApp</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
